package one.healthium.settings.ui.settings

import com.eygraber.uri.Uri
import io.ktor.util.encodeBase64
import one.healthium.domain.user.UserModel
import one.healthium.domain.user.models.PurchaseSource
import one.primehealth.app.BaseAppConfig

data class SettingsUiState(
    val userModel: UserModel? = null,
    val baseAppConfig: BaseAppConfig? = null,
    val manageSubscriptionEnabled: Boolean = false,
    val logoutInProgress: Boolean = false,
    val accountDeleted: Boolean = false,
    val error: Error? = null
) {
    val isMobilePurchase = userModel?.purchases?.purchaseSource == PurchaseSource.Mobile
    val subscriptionManagementUrl: String?
        get() {
            if (baseAppConfig == null || userModel == null || userModel.isLocalId) return null
            val userId = userModel.id
            val token = "{\"uid\": \"$userId\", \"pid\": \"${baseAppConfig.appId}\"}"

            return Uri.parse(baseAppConfig.subscriptionManagementUrl).buildUpon()
                .appendQueryParameter("token", token.encodeBase64())
                .build()
                .toString()
        }
}